module.exports = __webpack_public_path__ + "MediumIllustrationHouse@2x-1aWLChk.png";